import http from "./apiServices"

export const getInternalRemarks = ({ type, id }) => {
  return http.get(`${type}/${id}/internalRemarks`)
}

export const postInternalRemarks = ({ type, id, remarks }) => {
  return http.post(`${type}/${id}/internalRemarks`, { remarks })
}
